import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "form-custom col-lg-6" }
const _hoisted_2 = { class: "p-field" }
const _hoisted_3 = {
  class: "p-field-label",
  for: "name"
}
const _hoisted_4 = { class: "p-field" }
const _hoisted_5 = { class: "p-field-label" }
const _hoisted_6 = /*#__PURE__*/_createVNode("hr", null, null, -1)
const _hoisted_7 = { class: "p-field-radiobutton" }
const _hoisted_8 = { class: "p-field" }
const _hoisted_9 = { class: "p-field-label" }
const _hoisted_10 = /*#__PURE__*/_createVNode("hr", null, null, -1)
const _hoisted_11 = { class: "p-field-radiobutton" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")
  const _component_RadioButton = _resolveComponent("RadioButton")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("label", _hoisted_3, _toDisplayString(_ctx.$t("AppResource.Name")), 1),
      _createVNode(_component_InputText, {
        id: "name",
        type: "text",
        class: ["w-100", { 'input-error': !_ctx.isValidName }],
        modelValue: _ctx.roomObject.name,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.roomObject.name = $event))
      }, null, 8, ["modelValue", "class"]),
      _createVNode("label", {
        if: !_ctx.isValidName,
        for: "name",
        class: "fs-13 label-error"
      }, _toDisplayString(_ctx.invalidNameReason), 9, ["if"])
    ]),
    _createVNode("div", _hoisted_4, [
      _createVNode("label", _hoisted_5, _toDisplayString(_ctx.$t("AppResource.TypeOfObject")), 1),
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.typeOptions, (type) => {
        return (_openBlock(), _createBlock("div", {
          key: `option-${type}`
        }, [
          _hoisted_6,
          _createVNode("div", _hoisted_7, [
            _createVNode(_component_RadioButton, {
              id: `option-${type}`,
              name: "option",
              value: type,
              modelValue: _ctx.roomObject.thermoTypeOfObject,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.roomObject.thermoTypeOfObject = $event))
            }, null, 8, ["id", "value", "modelValue"]),
            _createVNode("label", {
              for: `option-${type}`
            }, _toDisplayString(_ctx.getOptionName(type)), 9, ["for"])
          ])
        ]))
      }), 128))
    ]),
    _createVNode("div", _hoisted_8, [
      _createVNode("label", _hoisted_9, _toDisplayString(_ctx.$t("AppResource.AssociatedPump")), 1),
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.associatedPumpOptions, (type) => {
        return (_openBlock(), _createBlock("div", {
          key: `associated-option-${type}`
        }, [
          _hoisted_10,
          _createVNode("div", _hoisted_11, [
            _createVNode(_component_RadioButton, {
              id: `associated-option-${type}`,
              name: "associated-option",
              value: type,
              modelValue: _ctx.roomObject.thermoAssociatedPump,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.roomObject.thermoAssociatedPump = $event))
            }, null, 8, ["id", "value", "modelValue"]),
            _createVNode("label", {
              for: `associated-option-${type}`
            }, _toDisplayString(_ctx.getAssociatedOptionName(type)), 9, ["for"])
          ])
        ]))
      }), 128))
    ])
  ]))
}